import { render, staticRenderFns } from "./new-user-popup.vue?vue&type=template&id=94a95c62&scoped=true"
import script from "./new-user-popup.ts?vue&type=script&lang=ts&external"
export * from "./new-user-popup.ts?vue&type=script&lang=ts&external"
import style0 from "./new-user-popup.scss?vue&type=style&index=0&id=94a95c62&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a95c62",
  null
  
)

export default component.exports